import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SIGN_OUT } from "../../store/Login/types";
import { Link } from "react-router-dom";

const UnAuthorizedPage = () => {
  const dispatch = useDispatch();
  console.debug("going here")

  const handleSignout = () =>{
    dispatch({ type: SIGN_OUT });
  }

  return (
    <>
      <div className="page-not-found">
        <div className="shadow-sm page-not-found-wrap">
        <div>
        <h1>Oops...!</h1>
        <h4>Page not found</h4>
        <div>
          The page you are looking for doesn't exit <br/> or an other error occured,
          go back to<br /> home page.
        </div>
        <Link to="/" onClick={handleSignout}>
          <button className="btn btn-primary btn-signup mt-3">Go Back</button>
        </Link>
        </div>

        <div>
          <img
            className="img-fluid"
            src="images/page-not-found.png"
            alt="404 page not found"
          />
        </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(UnAuthorizedPage);
